<template>
  <div v-bind:style="{ height: height + 'px' }">
    <ag-grid-vue
      style="width: 100%; height: 100%;"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :paginationAutoPageSize="false"
      :paginationPageSize="paginationPageSize"
      :pagination="true"
      id="OrdersGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :context="context"
      :frameworkComponents="frameworkComponents"
      :defaultColDef="defaultColDef"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import agGrid from "@/mixins/agGrid.js";
import SourceOrderNumberLink from "./cellRenderers/SourceOrderNumberLink";

export default {
  name: "OrdersGrid",
  data() {
    return {
      columnDefs: null,
      paginationPageSize: 100,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      overlayLoadingTemplate: true
    };
  },
  props: {
    height: {
      type: String,
      default: "600"
    }
  },
  components: {
    AgGridVue,
    SourceOrderNumberLink, // eslint-disable-line
  },
  mixins: [agGrid],
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady() {}
  },
  beforeMount() {
    this.gridOptions = {
      localeText: { noRowsToShow: "No Records Found" }
    };
    this.context = { componentParent: this };

    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex: 1,
      suppressMovable: true
    };

    this.columnDefs = [
      {
        headerName: "Order Number",
        field: "SourceOrderNumber",
        cellRendererFramework: "SourceOrderNumberLink",
      },
      {
        headerName: "Name",
        field: "Name"
      },
      {
        headerName: "Bill City",
        field: "City"
      },
      {
        headerName: "Bill State",
        field: "State"
      },
      {
        headerName: "Order Date",
        field: "OrderDate"
      }
    ];

    this.frameworkComponents = {
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
    rowData: {
      get() {
        let orders = this.$store.getters["orders/getOrders"];
        return orders.data;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

.ag-row-hover {
  background-color: #f3faf7 !important;
}
.ag-header-cell-label .ag-header-cell-text {
  white-space: normal !important;
  text-align: center;
}
</style>
